

const ws_config = {
    ws_server: 'https://api.mediker.kz',  // prod
    //ws_server: 'http://192.168.72.129:4000',      //test
    conf:{
        reconnectionDelayMax: 10000, 
        secure: true,    
    }
}

export default ws_config;